import { TransactionCreatorType, SummaryCustomerTransactionType } from "@/types/customer/transaction.type";
import { SummaryCustomerTransactionInterface } from "@/interface/customer/transaction";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";

export class SummaryCustomerTransaction implements SummaryCustomerTransactionInterface {
  id: string;
  location_id: string = "";
  serial_number: string;
  order_option: string;
  creation_time: string;
  discounted: boolean;
  refunded: boolean;
  total: number;
  tax: number;
  net: number;
  creator: TransactionCreatorType;
  payment_types: Array<string>;
  constructor(data: SummaryCustomerTransactionType) {
    this.id = data.id;
    this.location_id = data.location_id;
    this.serial_number = data.serial_number;
    this.order_option = data.order_option;
    this.creation_time = data.creation_time;
    this.discounted = data.discounted;
    this.refunded = data.refunded;
    this.total = data.total;
    this.tax = data.tax;
    this.net = data.net;
    this.creator = data.creator;
    this.payment_types = data.payment_types;
  }

  /***
   * get creator name
   * @return {string}
   */
  public soldBy(): string {
    return this.creator?.name;
  }

  /***
   * get time
   * @return {string}
   */
  public time(): string {
    return window.moment(this.creation_time).format("hh:mm:ss A");
  }

  /***
   * get date
   * @return {string}
   */
  public date(): string {
    return window.moment(this.creation_time).format("YYYY-MM-DD");
  }

  /***
   * get payment type
   * @return {string}
   */
  public paymentTypes(): string {
    return this.payment_types.join(",");
  }

  /***
   * get nat sale amount
   * @return {string}
   */
  public netAmount(): string {
    return (this.total / 1000).toFixed(3);
  }

  /***
   * get nat remaining balance
   * @return {number}
   */
  public remainingBalance(): number {
    return 0;
  }

  /***
   * get branch name
   * @return {any}
   */
  public getBranchName(): any {
    return Storage.get(StorageConstants.LOCATIONS)?.find((branch) => branch.id === this.location_id)?.name || "";
  }
}
